<template>
  <div v-if="visible" ref="popupEl" class="map-kit-popup">
    <button class="map-kit-popup-close" @click="close">&times;</button>
    <div class="map-kit-popup-content" v-html="content" />
  </div>
</template>

<script setup lang="ts">
import Overlay from 'ol/Overlay';
import { onMounted, ref, useTemplateRef, watch } from 'vue';

import { useMap } from '@/composables/useMap';
import type { PopupContent } from '@/types';

const props = defineProps<{
  popup?: PopupContent | null;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { map } = useMap();
const popupEl = useTemplateRef('popupEl');
const visible = ref(false);
const content = ref('');

let overlay: Overlay | null = null;

onMounted(() => {
  if (!map.value || !popupEl.value) return;
  overlay = new Overlay({
    element: popupEl.value,
    autoPan: { animation: { duration: 250 } },
    positioning: 'bottom-center',
    offset: [0, -12],
  });
  map.value.addOverlay(overlay);
});

watch(
  () => props.popup,
  (val) => {
    if (val) {
      visible.value = true;
      content.value = val.html;
      overlay?.setPosition(val.coordinate);
    } else {
      close();
    }
  },
);

const close = () => {
  visible.value = false;
  content.value = '';
  overlay?.setPosition(undefined);
  emit('close');
};
</script>
